<template>
	<HeaderGeneral
		@toggle="navigationToggle()"
		:routenameredirect="Routenameredirect"
		:btn-toggle="$vuetify.breakpoint.smAndDown"
	>
		<!-- Slot Seeker -->
		<!-- <template
			v-slot:seeker
			v-if="$vuetify.breakpoint.mdAndUp && !hasRol(1)"
		>
			<Seeker></Seeker>
		</template> -->

		<template v-slot:after>
			<!-- Nav -->
			<Nav
				v-if="$store.state.authenticated && $vuetify.breakpoint.mdAndUp"
			>
				<!-- Slot(Username) -->
				<template v-slot:username>
					{{ $store.state.acount.user.name }}
				</template>

				<!-- Slot Items -->
				<template v-slot:items>
					<!-- Opciones(Cliente) -->
					<template v-if="hasRol(6)">
						<v-list-item
							@click="
								$router.push({
									name: 'PurchasesIndex',
								})
							"
						>
							<v-list-item-title>
								Ordenes de compra
							</v-list-item-title>
						</v-list-item>
					</template>

					<v-list-item @click="logout()">
						<v-list-item-title>
							Cerrar sesión
						</v-list-item-title>
					</v-list-item>
				</template>
			</Nav>

			<template v-if="!hasRol(1)">
				<!-- Slot Seeker -->
				<!-- <Seeker
					v-slot:seeker
					v-if="$vuetify.breakpoint.smAndDown"
				></Seeker> -->

				<!-- <v-btn
					v-if="$vuetify.breakpoint.mdAndUp"
					elevation="0"
					color="transparent"
					class="mr-2 white--text"
					@click="menuOpen({ name: 'products_vertical' })"
				>
					<small>
						Productos
					</small>

					<v-icon>
						mdi-chevron-down
					</v-icon>
				</v-btn> -->

				<!-- MenúProductosVertical Component -->
				<!-- <MenuProductsVertical
					v-if="$vuetify.breakpoint.mdAndUp"
				></MenuProductsVertical> -->

				<!-- <v-btn
					v-if="$vuetify.breakpoint.mdAndUp"
					elevation="0"
					color="transparent"
					class="mr-2 white--text"
					@click="$router.push({ name: 'Search' })"
				>
					<small>
						Productos
					</small>
				</v-btn> -->

				<template
					v-if="
						!$store.state.authenticated &&
							$vuetify.breakpoint.mdAndUp
					"
				>
					<!-- Categories link -->
					<!-- <v-btn
						elevation="0"
						color="transparent"
						class="mr-2 white--text"
						v-if="$route.name != 'Search'"
						@click="$router.push({ name: 'Search' })"
					>
						<small>
							Productos
						</small>
					</v-btn> -->

					<!-- Login link -->
					<v-btn
						elevation="0"
						color="transparent"
						class="mr-2 white--text"
						v-if="$route.name != 'Login'"
						@click="$router.push({ name: 'Login' })"
					>
						<small>
							Iniciar sesión
						</small>
					</v-btn>
				</template>

				<!-- Home button -->
				<!-- <v-btn
					fab
					small
					elevation="0"
					class="mr-2"
					color="transparent"
					title="Ir al inicio"
					v-if="
						$route.name != 'StoreIndex' &&
							$vuetify.breakpoint.mdAndUp
					"
					@click="$router.push({ name: 'Store' })"
				>
					<v-icon class="white--text">
						mdi-home
					</v-icon>
				</v-btn> -->

				<!-- Cart Component-->
				<!-- <Cart class="ml-2"></Cart> -->
			</template>
		</template>

		<template v-slot:menus>
			<!-- MenúProductos Component -->
			<!-- <MenuProducts></MenuProducts> -->
		</template>
	</HeaderGeneral>
</template>

<script>
import { EventBus } from "@/main";

// Components
import Seeker from "@/components/Seeker";
import Cart from "@/components/Cart/Cart";
import Nav from "@/components/Nav";
import HeaderGeneral from "@/../../GeneralComponents/Header";
import MenuProducts from "@/components/Menus/Products";
import MenuProductsVertical from "@/components/Menus/ProductsVertical";

export default {
	components: {
		Nav,
		Cart,
		Seeker,
		HeaderGeneral,
		MenuProducts,
		MenuProductsVertical,
	},

	data() {
		return {};
	},

	methods: {
		hasRol(rolIdRequired) {
			if (this.$store.state.authenticated) {
				if (
					this.$store.state.acount.user.roles.find(
						(rol) => rol.id === rolIdRequired
					)
				) {
					return true;
				}
			}

			return false;
		},

		navigationToggle() {
			EventBus.$emit("navigationToggle");
		},

		menuOpen(data) {
			EventBus.$emit("MenuToggle", data);
		},

		logout() {
			EventBus.$emit("Logout");
		},
	},

	computed: {
		Routenameredirect() {
			return null;
			return this.$route.name != "StoreIndex" ? "StoreIndex" : "";
		},
	},
};
</script>

<style lang="css" scoped></style>
